import { DynamicContentType } from '../../types/content.types.js'
import { DateString } from '../../types/dateTime.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export enum DayOfWeek {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}

export interface OpeningHoursItem {
  /**
   * Eg: 18.5 for 18:30
   * Or 22.0 for 22:00
   */
  openHour: number
  /**
   * Eg: 18.5 for 18:30
   * Or 22.0 for 22:00
   */
  closeHour: number
}

export type OpeningHoursOrClosed = OpeningHoursItem | null

export interface OpeningHoursOverride {
  date: DateString // IsoDate
  openingHours: OpeningHoursOrClosed
}

export interface OpeningHoursData {
  // Null means closed
  defaultOpeningHours: Record<DayOfWeek, OpeningHoursOrClosed>
  overrides: OpeningHoursOverride[]
  marginBottom?: string
  marginTop?: string
}

export const openingHours: DynamicContentType<OpeningHoursData> = {
  name: 'openingHours',
  viewName: 'Öppettider',
  featureKey: 'openingHours',
  icon: LucideIconName.Clock2,
  uuid: '',
  data: {
    defaultOpeningHours: {
      [DayOfWeek.Monday]: null,
      [DayOfWeek.Tuesday]: null,
      [DayOfWeek.Wednesday]: null,
      [DayOfWeek.Thursday]: null,
      [DayOfWeek.Friday]: null,
      [DayOfWeek.Saturday]: null,
      [DayOfWeek.Sunday]: null,
    },
    overrides: [],
  },
}
